const { default: getFrontConfig } = require('../../common/getFrontConfig');
const { LIST_NAMES } = require('../analyticsConst');

const {
  vue: {
    BaseProductTile: {
      context: {
        homeShopTheLook,
        minicartSlider,
        pdpRecommendedSlider,
        pdpSlider,
        search,
        searchModal,
      },
    },
  },
} = getFrontConfig();
const { ANALYTICS_EVENTS } = require('../events');

/**
 * Build string for category/subcategory list data
 * 'Category-BAGS'
 * 'Subcategory-BAGS/CROSSBODY BAGS'
 * @param {Object} category category data from event
 * @returns {string} list name
 */
function buildItemListForCategory(category) {
  const categoryTitle = category?.parentCategories?.length === 1
    ? LIST_NAMES.category
    : LIST_NAMES.subcategory;
  const categories = category?.parentCategories?.map((parentCategory) => parentCategory.name).join('/').toUpperCase();
  return `${categoryTitle}-${categories}`;
}

/**
 * Return specific value for List parameter
 * @param {string} location
 * @param {string|null} parentCategoryName
 * @return {string} Where product tile click was made.
 */
const buildItemListForProductTileClick = (location, parentCategoryName) => {
  let tileList;
  switch (location) {
    case homeShopTheLook:
      tileList = ANALYTICS_EVENTS.PAYLOADS.productTileClicked.location.homeShopTheLook;
      break;
    case minicartSlider:
      tileList = ANALYTICS_EVENTS.PAYLOADS.productTileClicked.location.cartRecommendedProducts;
      break;
    case pdpRecommendedSlider:
      tileList = ANALYTICS_EVENTS.PAYLOADS.productTileClicked.location.pdpRecommendedProducts;
      break;
    case pdpSlider:
      tileList = ANALYTICS_EVENTS.PAYLOADS.productTileClicked.location.pdpCompleteTheLook;
      break;
    case search:
      tileList = ANALYTICS_EVENTS.PAYLOADS.productTileClicked.location.search;
      break;
    case searchModal:
      tileList = ANALYTICS_EVENTS.PAYLOADS.productTileClicked.location.searchModal;
      break;
    default:
      /*
      plpGrid
      plpGridFullWidth
      plpSliderBanner
      */
      tileList = parentCategoryName;
      break;
  }

  return tileList;
};

/**
 * Get list data from document.referrer
 * 'Direct' if there is no referrer, 'Other' otherwise
 * @returns {string} 'Direct' or 'Other'
 */
function buildItemListForReferrer() {
  const lastPath = /[^/]+(?=\/$|$)/;
  const referrer = lastPath.exec(document.referrer);
  return referrer ? LIST_NAMES.other : LIST_NAMES.direct;
}

module.exports = {
  buildItemListForCategory,
  buildItemListForProductTileClick,
  buildItemListForReferrer,
};
